import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, reactive, computed, provide } from 'vue';
  import { request } from '@/utils';
  import { useRoute, useRouter } from 'vue-router';
  import { ICustomPage } from '@/types/custom-page';
  import urlJoin from 'url-join';
  import { authStore } from '@/stores';
  import InjectImages from '@/templates/images';

  interface IProps {
    slug?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    slug: null
  },
  setup(__props: any) {

const props = __props as {
    slug?: string;
  }

  
  const pageInjectData = reactive<{[key: string]: any}>({ Images: InjectImages });
  const components = ref([]);
  const route = useRoute();
  const router = useRouter();
  let customPage: ICustomPage;

  const pageSlug = computed(() => {
    return props.slug || route.params.slug;
  });

  async function fetchData() {
    if (customPage) {
      const { target_type, target_id } = customPage;
      if (target_type === 'Program') {
        const { data: program } = await request.get(`/programs/${target_id}`);
        if (pageInjectData.program) {
          Object.assign(pageInjectData.program, program);
        } else {
          pageInjectData.program = program;
        }
        if (route.name === 'programs.show' && process.env.VUE_APP_ENV !== 'development') {
          checkOrigin(program);
        }
      }
    }
  }

  function checkOrigin(program: any) {
    // 判断当前域名是否为 program 自定义域名
    if (process.env.VUE_APP_SITE_ORIGIN !== window.location.origin) {
      const customDomain = program.custom_campaign_domain;
      // 如果没有设置自定义域名，需要跳到主域名下
      if (!customDomain) {
        window.location.href = urlJoin(process.env.VUE_APP_SITE_ORIGIN, route.fullPath);
      } else if (!window.location.origin.includes(customDomain)) {
        // 如果没有设置自定义域名，跟当前域名不一致，需要跳到自定义域名下。
        // 如果一致，不需要处理
        window.location.href = urlJoin(customDomain, route.fullPath);
      }
    }
  }

  // 如果进来，发现有 sso_token ,需要登录，并且删除query上的 sso_token, 以免出现问题
  async function checkCustomDomain() {
    const query = { ...route.query };
    if (query.sso_token && process.env.VUE_APP_SITE_ORIGIN !== window.location.origin) {
      await authStore.loginSsoToken(query.sso_token as string);
      delete query.sso_token;
      router.replace({ query });
    }
  }

  onMounted(async () => {
    const [{ data }] = await Promise.all([
      request.get(`/custom_pages/${pageSlug.value}`),
      checkCustomDomain(),
    ]);
    customPage = data;
    await fetchData();
    try {
      components.value = JSON.parse(data.configs).components || [];
    } catch (e) {
      components.value = [];
    }
  });

  provide('refreshPageData', fetchData);
  provide('editorMode', false);

return (_ctx: any,_cache: any) => {
  const _component_AppMeta = _resolveComponent("AppMeta")!
  const _component_AppCustomPage = _resolveComponent("AppCustomPage")!
  const _component_AppCustomPageContainer = _resolveComponent("AppCustomPageContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(pageInjectData).program)
      ? (_openBlock(), _createBlock(_component_AppMeta, _mergeProps({ key: 0 }, _unref(pageInjectData).program.seo_meta, {
          "share-title": _unref(pageInjectData).program?.share_setting?.title,
          "share-image": _unref(pageInjectData).program?.share_setting?.image
        }), null, 16, ["share-title", "share-image"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AppCustomPageContainer, _normalizeProps(_guardReactiveProps(_unref(pageInjectData))), {
      default: _withCtx(() => [
        _createVNode(_component_AppCustomPage, _mergeProps({ components: components.value }, _unref(pageInjectData)), null, 16, ["components"])
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

})